import { useSearch } from "@tanstack/react-router";
import { useState } from "react";
import { PersonsTable } from "@/components/persons/PersonsTable";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { originTarget, parseOriginSearch } from "@/lib/detail-origin";

export function PersonsPage() {
  // If we arrived from a page like Org Health (a tile deep-link), the trail
  // returns there instead of the catalog root. Frozen at mount: the table
  // rewrites this route's query string (filters) via replaceState, which would
  // otherwise drop the carried fromPage.
  const search = useSearch({ strict: false });
  const [origin] = useState(() => originTarget(parseOriginSearch(search)));
  useSetBreadcrumbs(
    origin
      ? [origin, { label: "People" }]
      : [{ label: "People & Organization" }, { label: "People" }],
  );

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="People & Organization"
        title="People"
        description="Browse the directory of team members and their capability — scoped to your visibility."
      />
      <PersonsTable />
    </div>
  );
}
